module.exports = __webpack_public_path__ + "img/logo-recuperi-boa-vista.cd793f98.png";